
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { Cliente } from '@/__env/lib/Clientes';
    import { Wait } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }
        public Estado: 'cargando' | 'ok' | 'vacio' = 'vacio';

        public Seleccionado: number = -1;
        @Watch( 'Seleccionado' )
        onSeleccionado()
        {


        }



        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        public async Buscar()
        {
            if ( !this.Busqueda )
                return;

            let b = this.Busqueda;
            await Wait( 500 );
            if ( this.Busqueda != b )
                return;

            if ( this.Estado == 'cargando' )
                return;

            this.Estado = 'cargando';
            this.$emit( 'busqueda', this.Busqueda );
            let e = await Cliente.find( { q: this.Busqueda } );
            this.Seleccionado = -1;
            this.Items = e.Items;
            this.Estado = 'ok';
        }

        public Resaltar( x: string )
        {
            return x.toUpperCase().replace( this.Busqueda.toUpperCase(), `<b>${this.Busqueda.toUpperCase()}</b>` );
        }

        public Seleccionar( x: Cliente )
        {
            this.Controlador.ClienteSeleccionado = x;
            this.Controlador.Vista.Modo = 'cliente';
        }

        private items: Cliente[] = [];
        public get Items(): Cliente[]
        {
            return this.items;
        }

        public set Items( a: Cliente[] )
        {
            this.items = a;
        }


        protected Eventos: Function[] = [];
        beforeDestroy() { this.Eventos.forEach( x => x() ); }
        mounted()
        {


        }

    }
